import React from 'react';

const ActiveFilters = ({ filterConditions, handleRemoveFilter, handleClearAll }) => {
    const activeFilters = Object.keys(filterConditions).filter(key => filterConditions[key]);

    return activeFilters.length > 0 && (
        <ul className="d-flex flex-wrap gap-2 mb-3">
            <li>
                <label className="d-block fw-semibold text-gray">Active Filters</label>
            </li>
            {activeFilters.map((filterKey) => (
                <li key={filterKey} className="d-flex align-items-center gap-2 p-2 fs-sm lh-1 border rounded-10">
                    <span className="d-block">{`${filterKey}: ${filterConditions[filterKey]}`}</span>
                    <a
                        href="javascript: void(0);"
                        className="text-black"
                        onClick={() => handleRemoveFilter(filterKey)}
                        style={{ textDecoration: 'none' }}
                    >
                        <span className="d-block material-symbols-outlined fs-md lh-1">close</span>
                    </a>
                </li>
            ))}
            <li className="d-flex align-items-center gap-2 p-2 fs-sm lh-1 border rounded-10">
                <span
                    className="d-block text-danger fw-bold"
                    style={{ cursor: 'pointer' }}
                    onClick={handleClearAll}
                >
                    <span className="material-symbols-outlined fs-md lh-1 text-danger">refresh</span>
                </span>
            </li>
        </ul>
    );
};



export default ActiveFilters;
